import { computed, ref } from "@vue/composition-api";
import { Group, InputGroupSearch } from "@scrile/api-provider/dist/api/GroupsProvider";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";

export type GroupWithCount = Group & { memberCount: number };

export function useGroups(options?: { system?: boolean; blockedUsers?: boolean }) {
  const loading = ref<boolean>(false);
  const { authUserStrict } = useAuthUser();

  const groups = ref<Group[]>([]);
  const getGroups = (data: InputGroupSearch) => providers.GroupsProvider.search({ data });
  const groupsWithPredefinedLists = computed<GroupWithCount[]>(() => {
    const list: GroupWithCount[] = [];
    list.push(...groups.value.map(i => ({ ...i, memberCount: i.memberIds.length })));
    return list;
  });

  const getData = async () => {
    try {
      loading.value = true;
      const requests: Promise<any>[] = [
        getGroups({
          ownerId: authUserStrict.value.id,
          system: options?.system === true ? undefined : false,
        }).then(g => (groups.value = g)),
      ];
      await Promise.all(requests);
    } finally {
      loading.value = false;
    }
  };
  return {
    loading,
    groups: groupsWithPredefinedLists,
    getData,
  };
}
